import { render } from "./ThePanelMenu.vue?vue&type=template&id=87313a06"
import script from "./ThePanelMenu.vue?vue&type=script&lang=js"
export * from "./ThePanelMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])